module.exports = __webpack_public_path__ + "media/images/games/fifa-20/rectangle-d1de840119ac57146e5df183574f71d7.jpg";